import * as table from './TableData'
import { CurrentTime, currentDate_dmy, loginUserIsCBMAttribRole, loginUserIsFranchisesRole } from "../../../components/Common/CommonFunction";
import { showActualAmount } from './TableData';
const getIsFranchises = () => loginUserIsFranchisesRole() || loginUserIsCBMAttribRole();

export const pageBorder = (doc) => {
    doc.line(817, 16, 30, 16);//horizontal line (Top)
    doc.line(30, 570, 30, 16);//vertical line (left)
    doc.line(817, 570, 817, 16);//vertical line (Right)
    doc.line(815, 570, 30, 570);//horizontal line (Bottom)   
}
export const pageHeder = (doc, data) => {
    doc.addFont("Arial", 'Normal')
    doc.setFont('Arial')
    doc.setFontSize(15)
    doc.text('Stock Report', 400, 30, 'center') //stock Header
}
export const reportHeder1 = (doc, data) => {
    doc.setFont('Tahoma')
    doc.setFontSize(14)
    doc.setFont(undefined, 'bold')
    doc.text(`*** ${data.PartyName} ***`, 400, 50, 'center')  //bill by 
    doc.line(815, 60, 30, 60) //horizontal line 1 billby upper
    doc.line(815, 16, 30, 16);//horizontal line 2
    doc.line(30, 400, 30, 16);//vertical left 1
    doc.line(407, 100, 407, 60); //vertical line middle 
    doc.line(30, 100, 815, 100) //horizontal line Current date upper

    var options3 = {
        margin: {},
        showHead: 'always',
        theme: 'plain',
        styles: {
            overflow: 'linebreak',
            fontSize: 8,
            height: 0,
        },
        bodyStyles: {
            columnWidth: 'wrap',
            textColor: [30, 30, 30],
            cellPadding: 3,
            fontSize: 9,
            fontStyle: 'bold',
            lineColor: [0, 0, 0]
        },
        columnStyles: {
            0: {
                valign: "top",
                columnWidth: 200,
                halign: 'left',
            },
        },
        tableLineColor: "black",
        startY: 63,
    };
    doc.autoTable(table.PageHedercolumns, table.ReportHederRows(data), options3);
}

export const reportHeder2 = (doc, data) => {
    doc.setFont('Tahoma')
    doc.setFontSize(10)
    doc.setFont(undefined, 'bold')
}
export const reportHeder3 = (doc, data) => {
    doc.setFont('Tahoma')
    doc.setFontSize(10)
    doc.setFont(undefined, 'bold')
}

export const reportFooter = (doc, data) => {
    doc.setFontSize(9)
}

export const tableBody = (doc, data) => {
    const isFranchises = getIsFranchises();
    var options = {
        didParseCell: (data1) => {
            if (data1.row.cells[0].raw === `Total`) {
                Object.keys(data1.row.cells).forEach(k => {
                    data1.row.cells[k].styles.fontSize = 8;
                    data1.row.cells[k].styles.fontStyle = "bold";
                });
            }
        },
        margin: { left: 30, right: 25 },
        theme: 'grid',
        headerStyles: {
            cellPadding: 4,
            lineWidth: 1,
            valign: 'top',
            fontStyle: 'bold',
            halign: 'center',
            fillColor: "white",
            textColor: [0, 0, 0],
            fontSize: 8,
            rowHeight: 10,
            lineColor: [0, 0, 0]
        },
        bodyStyles: {
            textColor: [30, 30, 30],
            cellPadding: 3,
            fontSize: 7,
            columnWidth: 'wrap',
            lineColor: [0, 0, 0],
        },
        columnStyles: {
            0: { valign: "top", columnWidth: 60 },
            1: { columnWidth: 57 },
            2: { columnWidth: 110 },
            3: { columnWidth: 30, halign: 'right'},
            4: { columnWidth: 56, halign: 'right' },
            5: { columnWidth: 45, halign: 'right' },
            6: { columnWidth: 45, halign: 'right' },
            7: { columnWidth: 45, halign: 'right' },
            8: { columnWidth: 45, halign: 'right' },
            9: { columnWidth: 45, halign: 'right' },
            ...(isFranchises ? { 10: { columnWidth: 45, halign: 'right' } } : {}),
            11: { columnWidth: 48, halign: 'right' },
            12: { columnWidth: 50, halign: 'right' },
            13: { columnWidth: 48, halign: 'right' },
            ...(showActualAmount ? { 14: { columnWidth: 40, halign: 'right' } } : {}),
            15: { columnWidth: 30, halign: 'right'},
        },
        tableLineColor: "black",
        startY: doc.autoTableEndPosY(45),
    };
    doc.autoTable(table.columns(), table.Rows(data, showActualAmount), options);
}

export const tableBody_for_ChitaleSweetsAndSnacks = (doc, data) => {
    var options = {
        didParseCell: (data1) => {
            if (data1.row.cells[0].raw === `Total`) {
                Object.keys(data1.row.cells).forEach(k => {
                    data1.row.cells[k].styles.fontSize = 8;
                    data1.row.cells[k].styles.fontStyle = "bold";
                });
            }
        },
        margin: { left: 30, right: 25 },
        theme: 'grid',
        headerStyles: {
            cellPadding: 4,
            lineWidth: 1,
            valign: 'top',
            fontStyle: 'bold',
            halign: 'center',
            fillColor: "white",
            textColor: [0, 0, 0],
            fontSize: 8,
            rowHeight: 10,
            lineColor: [0, 0, 0]
        },
        bodyStyles: {
            textColor: [30, 30, 30],
            cellPadding: 3,
            fontSize: 7,
            columnWidth: 'wrap',
            lineColor: [0, 0, 0],
        },
        columnStyles: {
            0: { valign: "top", columnWidth: 40 },
            1: { columnWidth: 50 },
            2: { columnWidth: 50 },
            3: { columnWidth: 46, halign: 'right' },
            4: { columnWidth: 35, halign: 'right' },
            5: { columnWidth: 40, halign: 'right' },
            6: { columnWidth: 45, halign: 'right' },
            7: { columnWidth: 42, halign: 'right' },
            8: { columnWidth: 40, halign: 'right' },
            9: { columnWidth: 40, halign: 'right' },
            10: { columnWidth: 40, halign: 'right' },
            11: { columnWidth: 45, halign: 'right' },
            12: { columnWidth: 30, halign: 'right' },
            13: { columnWidth: 35, halign: 'right' },
            14: { columnWidth: 37, halign: 'right' },
            15: { columnWidth: 33, halign: 'right' },
             ...(showActualAmount ? { 16: { columnWidth: 45, halign: 'right' } } : {}),
            17: { columnWidth: 30, halign: 'right'},
            18: { columnWidth: 33, halign: 'right'},
            19: { columnWidth: 30, halign: 'right'},

        },
        tableLineColor: "black",
        startY: doc.autoTableEndPosY(45),
    };

    // ✅ Changed this line only — call columns_for_ChitaleSweetsAndSnacks() as a function
    doc.autoTable(
        table.columns_for_ChitaleSweetsAndSnacks(),
        table.Rows_for_ChitaleSweetsAndSnacks(data, showActualAmount),
        options
    );
}

export const pageFooter = (doc, data) => {
    let finalY = doc.previousAutoTable.finalY;
    pageBorder(doc)
    reportFooter(doc, data)

    const pageCount = doc.internal.getNumberOfPages()
    doc.setFont('helvetica', 'Normal')
    doc.setFontSize(8)
    for (var i = 1; i <= pageCount; i++) {
        doc.setPage(i)
        doc.text('Page ' + String(i) + ' of ' + String(pageCount), 790, 580, { align: 'center' })
        doc.text('Print Date :' + String(currentDate_dmy) + ' Time ' + String(CurrentTime()), 30, 580)
    }
}
